(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jfg-hero3d"] && !Shopify.designMode) return;
  try {
    
function initJetForceCinema(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const video=root.querySelector('video'),button=root.querySelector('button');if(!video||!button)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');let wanted=!reduce.matches,visible=true;
  function label(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(!video.paused))}
  function play(){if(!video.src)video.src=video.dataset.src;video.play().catch(label)}
  video.addEventListener('playing',()=>{root.classList.add('is-playing','has-frame');label()});
  video.addEventListener('pause',()=>{root.classList.remove('is-playing');label()});
  video.addEventListener('error',()=>{root.classList.remove('is-playing','has-frame');label()});
  button.addEventListener('click',()=>{wanted=video.paused;if(wanted)play();else video.pause()});
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(wanted&&visible&&!document.hidden)play();else video.pause()});observer.observe(root);
  document.addEventListener('visibilitychange',()=>{if(wanted&&visible&&!document.hidden)play();else video.pause()});
  reduce.addEventListener('change',()=>{wanted=!reduce.matches;if(wanted&&visible)play();else video.pause()});
  root.addEventListener('jfc:cleanup',()=>{observer.disconnect();video.pause()});label();
}
document.querySelectorAll('[data-jfc]').forEach(initJetForceCinema);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-jfc]').forEach(initJetForceCinema));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-jfc]').forEach(root=>root.dispatchEvent(new Event('jfc:cleanup'))));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jfg-story"] && !Shopify.designMode) return;
  try {
    
function initJetForceStory(root){
  if(root.dataset.ready)return;root.dataset.ready="true";
  var steps=root.querySelectorAll('.jfs__step'),rail=root.querySelectorAll('.jfs__rail li'),feel=root.querySelector('[data-feel]'),lvl=root.querySelector('[data-level]');
  var frames=root.querySelectorAll('[data-frame]'),reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  var T=Number(root.dataset.temp),V=Number(root.dataset.speed),n=steps.length||1,cur=-1,ticking=false;
  var p16=Math.pow(V,0.16),wct=13.12+0.6215*T-11.37*p16+0.3965*T*p16;
  feel.textContent=Math.round(wct)+' °C';
  function clamp(x){return x<0?0:x>1?1:x;}
  function update(){
    ticking=false;
    var r=root.getBoundingClientRect(),h=root.offsetHeight-window.innerHeight;
    var p=clamp(-r.top/(h||1));
    var idx=Math.min(n-1,Math.floor(p*n*0.999));
    var local=p*n-idx;
    var transition=clamp((local-0.84)/0.16);
    transition=transition*transition*(3-2*transition);
    var turn=Math.min(3,idx+transition);
    var heat=turn/3;
    var from=Math.floor(turn),blend=turn-from;
    if(reduce.matches){from=Math.round(turn);blend=0;}
    for(var f=0;f<frames.length;f++){
      var opacity=f===from?1-blend:f===from+1?blend:0;
      frames[f].style.opacity=opacity.toFixed(3);
      frames[f].style.transform=reduce.matches?'none':'rotateY('+((f-turn)*8).toFixed(2)+'deg) rotateZ('+(-3+heat*6).toFixed(2)+'deg)';
    }
    var flow=idx===0?0:idx===1?clamp(local*1.6):1;
    root.style.setProperty('--p',p.toFixed(3));
    root.style.setProperty('--heat',heat.toFixed(3));
    root.style.setProperty('--flow',flow.toFixed(3));
    if(idx!==cur){
      cur=idx;
      for(var i=0;i<steps.length;i++){steps[i].classList.toggle('is-on',i===idx);steps[i].classList.toggle('is-past',i<idx);if(rail[i])rail[i].classList.toggle('is-on',i===idx);}
      var lv=parseInt(steps[idx].getAttribute('data-level'),10)||0;
      root.setAttribute('data-lv',lv);
      lvl.textContent=lv?(root.dataset.levelLabel+' '+lv):root.dataset.offLabel;
    }
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll);reduce.addEventListener('change',onScroll);
  update();
}
document.querySelectorAll('[data-jfs]').forEach(initJetForceStory);
document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-jfs]').forEach(initJetForceStory);});

  } catch(e) { console.error(e); }
})();
})();
